import { render } from "./CreateLocationModal.vue?vue&type=template&id=66ff4258&scoped=true"
import script from "./CreateLocationModal.vue?vue&type=script&lang=js"
export * from "./CreateLocationModal.vue?vue&type=script&lang=js"

import "./CreateLocationModal.vue?vue&type=style&index=0&id=66ff4258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ff4258"]])

export default __exports__